module.exports = __webpack_public_path__ + "Icon_Items Format.4f4494620bc0a36e7d77.png";